import GridContainer, { GridOffset } from "@insite/mobius/GridContainer";
import React, { useEffect } from "react";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import translate from "@insite/client-framework/Translate";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Select from "@insite/mobius/Select";
import { css } from "styled-components";
import { CreditCardDtoCollection, updateSavedCreditCards } from "@NA/Services/SavedCreditCardsService";
import Button, { ButtonPresentationProps, ButtonWrapper } from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import ADIColors from "@NA/Utils/ADIColors";
import { FormFieldStyle } from "@insite/mobius/FormField";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { FileUpload, LazyImage, Link } from "@insite/mobius/index";
import CustomModel from "@NA/Components/ADICustomModalRequestQuote";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { IconWrapper } from "@insite/mobius/Icon";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";


export interface AdiEditCreditCardModalStyles {
    uploadProductListGridItem: GridItemProps;
    subHeadings?: TypographyProps;
    subDescription?: TypographyProps;
    filesAndProductText: TypographyProps;
    fileuploadStyledWrapper?: InjectableCss;
    uploadStyledWrapper?: InjectableCss;
    fileuploadedStyledWrapper?: InjectableCss;
    actionGridItem?: GridItemProps;
}

export const adiEditCreditCardModalStyles: AdiEditCreditCardModalStyles = {
    uploadProductListGridItem: {
        width: 12,
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    subHeadings: {
        css: css`
            color: ${ADIColors.darkBlue1};
            font-size: 24px;
            line-height: normal;
            margin-top: 0;
            font-weight: bold !important;
        `,
    },
    subDescription: {
        css: css`
            margin-top: 10px;
            margin-bottom: 10px;
        `,
    },
    filesAndProductText: {
        css: css`
            color: ${ADIColors.danger} !important;
            text-align: left !important;
            font-weight: 600 !important;
            letter-spacing: -0.06px;
        `,
    },
    fileuploadStyledWrapper: {
        css: css`
            width: 100%;
            max-height: 100px;
            padding: 0 !important;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            border: 1px dashed ${ADIColors.gray10};
            background-color: ${ADIColors.white};
            position: relative;
            max-width: 817px;
            margin: 0 auto;
        `,
    },
    uploadStyledWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            ${FormFieldStyle} {
                display: none !important;
            }
            ${ButtonWrapper} {
                background-color: transparent;
                border: none;
                margin: 0;
                padding: 0;
                margin-top: 5px;
                padding-left: 5px;
                > ${TypographyStyle} {
                    margin-left: 0px;
                }
                > span {
                    color: ${getColor("primary")};
                    font-size: 16px;
                    font-weight: 800;
                    margin: 0;
                    padding: 0;
                }
                :hover {
                    background-color: ${ADIColors.white};
                    border: none;
                }
            }
            > ${StyledWrapper} {
                display: flex;
                justify-content: center;
                align-items: center;
            }
        `,
    },
    fileuploadedStyledWrapper: {
        css: css`
            width: 100%;
            max-height: 100px;
            padding: 0 !important;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${ADIColors.white};
        
           
            position: relative;
            max-width: 817px;
            margin: 0 auto;
            font-size: 14px;
        `,
    },
    actionGridItem: {
        width: 12,
        css: css`
            display: flex;
            justify-content: end;
            padding: 0 !important;
        `,
     },
};

const styles = adiEditCreditCardModalStyles;

interface OwnProps {
    isOpen: boolean;
    closeQuoteModal: any;
    invalidMessage: string;
    formErrors: any;
    handleDrop: any;
    handleDragOver: any;
    handleDragLeave: any;
    handleDragStart: any;
    onAddFile: any;
    files: any;
    onRemoveFile: any;
    setDropzone: any;
    setuploadBorder: any;
    setFormQuotedata?:any
}
const downloadTemplate = () => {
    let downloadFileName = "Product list template";
    let headers = ["Item Count", "Item Number", "Description"];
    let csvContent = "data:text/csv;charset=utf-8," + headers.join(",") + "\n";
    const hiddenElement = document.createElement('a');
    hiddenElement.href = encodeURI(csvContent);
    hiddenElement.target = '_blank';
    hiddenElement.download = `${downloadFileName}.csv`;
    hiddenElement.click();
  };

type Props = OwnProps;

const ADIRequestQuoteUploadModal = ({
    isOpen,
    closeQuoteModal,
    invalidMessage,
    formErrors,
    handleDrop,
    handleDragOver,
    handleDragLeave,
    handleDragStart,
    onAddFile,
    files,
    onRemoveFile,
    setDropzone,
    setuploadBorder,
    setFormQuotedata
}: Props) => {
    useEffect(() => {
        setDropzone(document.getElementById("dropzone"));
        setuploadBorder(document.getElementById("uploadBorder"));
    });
    return (
        <CustomModel
            headline={translate("Upload a list of Products")}
            isOpen={isOpen}
            errorStyle={false}
            handleClose={closeQuoteModal}                 
        >
            <>
                <GridItem width={12} {...styles.uploadProductListGridItem}>
                    <Typography as="div" {...styles.subDescription}>
                        <Typography as="a" color="blue" onClick={downloadTemplate}>
                            {translate("Download ")}
                        </Typography>
                        {translate(
                            "our product quotation CSV template and upload your product list to the file exchange below (max. 50 rows).",
                        )}
                    </Typography>
                    <Typography {...styles.filesAndProductText}>{formErrors.filesAndProduct}</Typography>
                    <StyledWrapper {...styles.fileuploadStyledWrapper} id="uploadBorder" style={{
                        border: formErrors.filesAndProduct ?  '1px dashed red' : `1px dashed ${ADIColors.gray10}`,
                    }}>
                        <StyledWrapper
                            {...styles.uploadStyledWrapper}
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            id="dropzone"
                        >
                            <StyledWrapper draggable={true} onDragStart={handleDragStart}>
                                <LazyImage
                                    width="50px"
                                    height="auto"
                                    src="https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/icons/drop-files.png"
                                />
                                <Typography>{translate("Drop files to attach, or")}</Typography>
                                <FileUpload buttonText="browse." onChange={onAddFile} />
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                    {files.length > 0 && (
                        <StyledWrapper {...styles.fileuploadedStyledWrapper}>
                            <GridContainer>
                                {files.map((item: any) => (
                                    <GridItem width={4} key={item.name}>
                                        <Typography >
                                            {/* {item.name}{" "} */}
                                            {translate("File uploaded.")}
                                            <Link as="a" onClick={() => onRemoveFile(item.name)}>
                                                {" "}
                                                &nbsp; Remove
                                            </Link>
                                        </Typography>
                                    </GridItem>
                                ))}
                            </GridContainer>
                        </StyledWrapper>
                    )}
                    {invalidMessage && <Typography {...styles.filesAndProductText}>{invalidMessage}</Typography>}
                </GridItem>
                <GridItem width={12} {...styles.actionGridItem}>
                    <Button type="button" onClick={closeQuoteModal} variant="tertiary" style={{ marginRight: "5px" }}>
                        {translate("Cancel")}
                    </Button>
                    <Button type="submit" variant="primary" disabled={files.length === 0} onClick={()=>{
                        setFormQuotedata(); 
                        closeQuoteModal()
                    }
                        }>
                        {translate("Import and Review")}
                    </Button>
                </GridItem>
            </>
        </CustomModel>
    );
};

export default ADIRequestQuoteUploadModal;
